<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Arrival/Departure Officer Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button :export-country="country" :export-date="range"
                                        model="arrival-departure-officerwise"
                                        v-if="$oauth.checkIfHasPermission(['export arrival-departure-summary-report'])"/>
          <refresh-button :click-function="updateByOfficer"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex class="d-flex align-center" xs6>
              <custom-date-range-picker @change="updateByOfficer"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="offices"
                  clearable
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Office"
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="office"
                  @change="updateByOfficer"
              />
            </v-flex>
          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read arrival-departure-summary-report'])"
            >
              <thead>
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th>Officer Name</th>
                <th>Shifts</th>
                <th class="text-center">Created At</th>
                <th class="text-center">Designation</th>
                <th class="text-center">Arrival</th>
                <th class="text-center">Departure</th>
                <th class="text-center">Total</th>
              </tr>
              </thead>
              <tbody v-if="officer_wise_data">
              <tr v-for="(item,i) in officer_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.full_name }}<br><span>( {{item.office_name}} )</span></td>
                <td>{{ item.total_shifts }}</td>
                <td class="text-center">{{ item.created_at }}</td>
                <td class="text-center">{{ item.designation }}</td>
                <td class="text-center">{{ item.total_arrival }}</td>
                <td class="text-center">{{ item.total_departure }}</td>
                <td class="text-center">{{ item.total }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="4">Total</td>
                <td class="text-center">{{  }}</td>
                <td class="text-center">{{ total_arrival }}</td>
                <td class="text-center">{{ total_departure }}</td>
                <td class="text-center">{{ total_total }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const AD_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/arrival-departure-officerwise`;

export default {
  name: "ADOfficerWiseReport",
  data() {
    return {
      total_arrival: 0,
      total_departure: 0,
      total_total:0,
      officer_wise_data: [],
      range: {},
      office: null,
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices.filter(item=>{
        return item.type === 2 || item.type === 3;
      });
    },

  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries",
      fetchOfficers: "UserList/getAll",
      fetchOffices:"OfficeList/fetchData"
    }),
    arrivedReport(item) {
      let params = {fromAD: true, type: 'Arrival', country: item.country};
      this.$router.push({
        name: 'ArrivalDepartureReport',
        params: params
      });
    },

    departedReport(item) {
    },
    updateByOfficer() {
      let params = {};
      this.progressLinearLoading = true;
      if (this.range)
        params.date_range = this.range;
      if (this.office)
        params.office = this.office;

      this.total_arrival = 0;
      this.total_departure = 0;
      this.total_total = 0;
      Http.get(AD_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.officer_wise_data = res.data.data;
            this.officer_wise_data.forEach(item => {
              this.total_arrival += item.total_arrival;
              this.total_departure += item.total_departure;
              this.total_total += item.total;
            })
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    this.progressLinearLoading = true;
    this.fetchOffices();
    Http.get(AD_SUMMARY_REPORT_URL)
        .then((res) => {
          this.officer_wise_data = res.data.data;
          this.officer_wise_data = res.data.data;
          this.officer_wise_data.forEach(item => {
            this.total_arrival += item.total_arrival;
            this.total_departure += item.total_departure;
            this.total_total += item.total;
          })
          this.progressLinearLoading = false;
          // this.getData();
        })
        .catch(() => {
          this.progressLinearLoading = false;

        });
    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }

  }
}
</script>
